exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".danger[data-v-10604ac2]{color:red}select[data-v-10604ac2]{margin-bottom:1rem}textarea[data-v-10604ac2]{line-height:1.5rem}input[type=submit][data-v-10604ac2]{transition:all .3s ease}input[type=submit][data-v-10604ac2]:disabled{background:#ccc}.change-lang[data-v-10604ac2]{cursor:pointer;display:block;font-weight:700;font-size:1.5rem;line-height:1rem;color:#036}p.link[data-v-10604ac2]{text-align:right}p.link a[data-v-10604ac2]{color:#333;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-10604ac2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calc/Translate.vue
// module id = 156
// module chunks = 0